/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';
import { ElCalendarKitModule } from '../calendar-kit/calendar-kit.module';
import { ElCardModule } from '../card/card.module';
import { ElBaseCalendarComponent } from './base-calendar.component';


@NgModule({
  imports: [ElCalendarKitModule, ElSharedModule, ElCardModule],
  exports: [ElBaseCalendarComponent],
  declarations: [ElBaseCalendarComponent],
})
export class ElBaseCalendarModule {
}
